import { SelectTypeProps } from 'screens/PlayerLoggedInScreen/props';

const SelectType: React.FC<SelectTypeProps> = ({}) => {
  return <div>SelectType</div>;
};

export default SelectType;
